import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Home } from 'lucide-react';

const ROUTE_LABEL_KEYS: Record<string, string> = {
  dashboard: 'breadcrumbs.dashboard',
  tickets: 'breadcrumbs.tickets',
  new: 'breadcrumbs.new',
  'open-order': 'breadcrumbs.open-order',
  address: 'breadcrumbs.address',
  support: 'breadcrumbs.support',
  help: 'breadcrumbs.help',
  notifications: 'breadcrumbs.notifications',
  health: 'breadcrumbs.health',
  admin: 'breadcrumbs.admin',
  'sla-configs': 'breadcrumbs.sla-configs',
  users: 'breadcrumbs.users',
  operators: 'breadcrumbs.operators',
  'api-keys': 'breadcrumbs.api-keys',
  'audit-log': 'breadcrumbs.audit-log',
  profile: 'breadcrumbs.profile',
  'change-password': 'breadcrumbs.change-password',
};

export function Breadcrumbs() {
  const location = useLocation();
  const { t } = useTranslation('common');
  const segments = location.pathname.split('/').filter(Boolean);

  // Don't show breadcrumbs on dashboard
  if (segments.length <= 1 && segments[0] === 'dashboard') return null;
  if (segments.length === 0) return null;

  const crumbs = segments.map((seg, i) => {
    const path = '/' + segments.slice(0, i + 1).join('/');
    const labelKey = ROUTE_LABEL_KEYS[seg];
    const label = labelKey
      ? t(labelKey)
      : (segments[i - 1] === 'tickets' && seg !== 'new' ? t('breadcrumbs.ticketDetail') : seg);
    const isLast = i === segments.length - 1;

    return { path, label, isLast };
  });

  return (
    <div className="flex items-center gap-2 px-4 md:px-8 py-2.5 bg-slate-100/60 border-b border-slate-200 text-sm">
      <Link to="/dashboard" className="text-brand-rose hover:text-brand-purple transition-colors">
        <Home className="w-4 h-4" />
      </Link>
      {crumbs.map((crumb) => (
        <span key={crumb.path} className="flex items-center gap-2">
          <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
          {crumb.isLast ? (
            <span className="text-slate-600 font-medium">{crumb.label}</span>
          ) : (
            <Link to={crumb.path} className="text-brand-rose hover:text-brand-purple transition-colors">
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </div>
  );
}
